import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/RootState';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.jitRequests || initialState;

export const selectJitRequests = createSelector([selectDomain], state => state);
